(function($){

    $(document).ready(function () {

        // Mobile menu animations
        $('#triggerContainer').on('click', function(){

          // close menu
          if($(this).hasClass('open')){

            $(this).removeClass('open');
            $('body').removeClass('disable');
            $('html').removeClass('disable');
            $('#mainMenu').animate({right: '-100vw'}, 300, 'linear');

          // open menu
          } else {

            $('body').addClass('disable');
            $('html').addClass('disable');
            $('#mainMenu').animate({right: '0px'}, 300, 'linear');
            $(this).addClass('open');

          }

        });

        // animate on link click
        $('#mainMenu a[href]').on('click', function(){

          if($('#trigger').hasClass('open')){

            $('#trigger').removeClass('open');
            $('body').removeClass('disable');
            $('html').removeClass('disable');
            $('#mainMenu').animate({right: '-100vw'}, 300, 'linear');

          }

        });

        // submenu toggle
        function myFunction(mainMenu) {

          if (mainMenu.matches) {

            $('#mainMenu .menu-item-has-children > a').on('click', function(){
              $(this).parent('li').toggleClass('opened');
              $(this).siblings('ul').slideToggle();
            });
            
          }

        }

        var mainMenu = window.matchMedia("(max-width: 1199px)")
        myFunction(mainMenu)
        mainMenu.addListener(myFunction)


        // Sticky header
        $(window).scroll(function() {
            if ($(this).scrollTop() > 400){
                $('#siteHeader').addClass("is-sticky");
            } else {
                $('#siteHeader').removeClass("is-sticky");
            }
        });


        // Go to top button
        $(window).scroll(function() {
            if ($(this).scrollTop() > 600){
                $('#goTop').addClass("active");
            } else {
                $('#goTop').removeClass("active");
            }
        });


        // Scroll on click
        $(document).on('click', 'a[href^="#"]', function (event) {
            event.preventDefault();
            $('html, body').animate({
                scrollTop: $($.attr(this, 'href')).offset().top
            }, 1000);
        });


        // Initiate aos animations
        AOS.init();


        // Remove empty paragraphs
        $('p:empty:not([role])').remove();


        // Remove p tags around images when using the WYSIWYG advanced custom field
        $('p > img').unwrap();

    });

})(jQuery);